import { IconButton } from "@mui/material";
import { ISelectRow } from "../../libs/dropdown/Dropdown";
import GNumberField from "../../libs/textfield/GNumberField";
import GTextSelect from "../../libs/textfield/GTextSelect";
import { IFoodAmount, TUnit } from "../../shared/Recipes";
import FoodList from "../FoodList";
import { AddOutlined, DeleteOutline } from "@mui/icons-material";
import { useEffect, useRef, useState } from "react";
import { unit2option, UnitOptions } from "../../data/RecipeCache";

export interface IFoodRowProps {
    index:number
    foodAmount:IFoodAmount
    foodIds:number[]
    onAdd?:(food:IFoodAmount) => void
    onDelete?:(index:number) => void
    onUpdate?:(index:number,food:IFoodAmount) => void
}
export default function FoodRow(props:IFoodRowProps){
    const [foodId,setFoodId] = useState<number>(props.foodAmount.id)
    const [amount,setAmount] = useState<string>(props.foodAmount.amount.toString())
    const [unit,setUnit] = useState<ISelectRow<string>>(unit2option(props.foodAmount.unit))
    const mounted = useRef<boolean>(false)

    useEffect(() => {
        if (mounted.current) props.onUpdate?.(props.index, {id:foodId,amount:parseInt(amount),unit:unit.value as TUnit})
        else mounted.current = true
    }, [foodId,amount,unit])

    const onFood = (e:any,selected:ISelectRow<number>|null) => { setFoodId(selected?.value||0) }
    const onAmount = (e:any) => { setAmount(e.target.value) }
    const onUnit = (e:any,selected:ISelectRow<string>|null) => { setUnit(selected!) }
    const onAdd = (e:any) => props.onAdd?.({id:foodId,amount:parseFloat(amount),unit:unit.value as TUnit})
    const onDelete = (e:any) => props.onDelete?.(props.index)

    const action = props.index<0 ? <IconButton onClick={onAdd} disabled={!foodId || !amount}><AddOutlined/></IconButton> : 
        <IconButton onClick={onDelete}><DeleteOutline/></IconButton>

    const defaultUnit = unit2option(props.foodAmount.unit)
    return <div className="row">
            <FoodList foodId={props.foodAmount.id} onChange={onFood} index={props.index} foodIds={props.foodIds}/>
            <GNumberField placeholder="Amount" value={amount.toString()} onChange={onAmount}/>
            <GTextSelect options={UnitOptions} value={unit} defaultValue={defaultUnit} onChange={onUnit} hideArrow={true}/>
            {action}
    </div>
}